import * as React from 'react';
import { useDropzone, type DropzoneOptions, type FileRejection } from 'react-dropzone';
import DocumentIcon from 'src/assets/img/document-icon.png';
import { useNotification } from 'src/hooks/use-notification';
import { StyledDropZone, StyledDropArea } from './DropZone.styled';
import { P14 } from '../Typography';

export interface DropZoneProps {
  onDrop: NonNullable<DropzoneOptions['onDrop']>;
  accept: NonNullable<DropzoneOptions['accept']>;
  maxSize: NonNullable<DropzoneOptions['maxSize']>;
  maxFiles: NonNullable<DropzoneOptions['maxFiles']>;
  disabled: boolean;
}

export const DropZone: React.FunctionComponent<DropZoneProps> = ({ onDrop, accept, maxSize, maxFiles, disabled }) => {
  const { enqueueErrorNotification } = useNotification();

  const handleFileReject = (fileRejections: FileRejection[]) => {
    const { errors } = fileRejections[0];
    enqueueErrorNotification(errors?.[0]?.message || 'File is not valid');
  };

  const { getRootProps, getInputProps, isDragActive, isFocused } = useDropzone({
    onDrop,
    accept,
    maxSize,
    maxFiles,
    onDropRejected: handleFileReject,
    disabled: disabled,
  });

  const acceptableFilesFormat = [...new Set(Object.values(accept || {}).flat())].join(', ');

  return (
    <StyledDropZone {...getRootProps()}>
      <input {...getInputProps()} />
      <StyledDropArea $isFocused={isFocused || isDragActive} $disabled={disabled} className="drop-area">
        <img src={DocumentIcon} alt="document icon" />
        {isDragActive ? (
          <P14>Drop the files here ...</P14>
        ) : (
          <>
            <P14>Drag n&apos; drop some files here, or click to select files</P14>
            <P14>Supported file format: {acceptableFilesFormat}</P14>
          </>
        )}
      </StyledDropArea>
    </StyledDropZone>
  );
};
